/**
 * "Sponsored by <organization>" on the contact page (Sheepdog build, migration 2026-10-19-580). READ-ONLY.
 * Shown only when the contact's household has (or had) a sponsored subscription; renders nothing otherwise, and
 * nothing when the viewer may not read sponsorships (the RPC refuses non-staff).
 */

import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { formatDateMDY } from "../../utils/formatters";
import {
  getContactSponsorship,
  programDisplay,
} from "../../services/sponsorship.service";

const ContactSponsorshipBadge: React.FC<{
  contactId: string;
  className?: string;
}> = ({ contactId, className = "" }) => {
  const q = useQuery({
    queryKey: ["contact-sponsorship", contactId],
    queryFn: () => getContactSponsorship(contactId),
    retry: false,
  });
  const s = q.data;
  if (!s || !s.sponsored) {
    return null;
  }
  const ended = s.status === "ended";
  const who = s.organization_name ? (
    s.organization_id ? (
      <Link
        to={`/organizations/${s.organization_id}`}
        className="font-medium underline hover:no-underline"
      >
        {s.organization_name}
      </Link>
    ) : (
      <span className="font-medium">{s.organization_name}</span>
    )
  ) : (
    <span className="font-medium">an organization (not linked yet)</span>
  );
  return (
    <p
      className={`text-sm ${ended ? "text-gray-600" : "text-indigo-800"} ${className}`}
      data-testid="contact-sponsorship-badge"
    >
      <span
        className={`inline-flex items-center mr-2 px-2 py-0.5 rounded text-xs font-medium ${
          ended ? "bg-gray-100 text-gray-600" : "bg-indigo-100 text-indigo-800"
        }`}
      >
        {programDisplay(s.program)}
      </span>
      {ended ? "Was sponsored by " : "Sponsored by "}
      {who}
      {ended && s.ended_on ? ` · ended ${formatDateMDY(s.ended_on)}` : ""}
      {!ended && s.since ? ` · since ${formatDateMDY(s.since)}` : ""}
    </p>
  );
};

export default ContactSponsorshipBadge;
